import React from 'react'
import { useNavigate } from 'react-router-dom'

const NoticePopup = ({ open }) => {
  const navi = useNavigate()
  if (open) {
    document.querySelector('.application_sheet').scrollTop = 0
  }
  return (
    <div className="NoticePopup">
      <div className={open ? 'open error_popup notice_popup' : 'error_popup notice_popup'}>
        <div className="logo_brg"></div>
        <p>
          아이폰 보안 이슈로 수정중에 있습니다
          <br />
          pc 또는 안드로이드 환경에서 이용해 주시기 바랍니다.
        </p>
        <div className="logo_caution"></div>
        <div>
          <button type="button" className="btn_default" onClick={() => navi('/')}>
            메인으로
          </button>
        </div>
      </div>
    </div>
  )
}

export { NoticePopup }
